import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoLocaleService } from '@ngneat/transloco-locale';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'monthAndYear'
})
export class MonthAndYearPipe implements PipeTransform {
  constructor(private translocoLocaleService: TranslocoLocaleService) {}

  transform(value: Date): Observable<string> {
    return this.translocoLocaleService.localeChanges$.pipe(
      map(locale => this.translocoLocaleService.localizeDate(value, locale, { dateStyle: 'long' }).replace(/^[0-9]?[0-9][\\.]? /g, ''))
      // The below would only work, if language packages for Angular are installed. We don't want to do that so we use the above dirty hack.
      // map(locale => new DatePipe(locale).transform(date, 'MMMM yyy'))
    );
  }
}
